import * as React from 'react';
import  PapaJohnsBannerImage  from './PapaJohnsBannerImage';
import { connect } from 'react-redux';
import * as Request from '../tgccRequest';
import { browserHistory } from 'react-router';
import Radium, { StyleRoot } from 'radium';
import  { PapaJohnsFooter}  from './PapaJohnsFooter'; 
import * as Tgcc from '../tgccGlobal';
import { Dispatch } from 'redux';
import ProgressBar from '../Components/ProgressBar';
import BackButton from '../Components/BackButton';


const colorPalette = {
    red: '#D60A00', // Papa Johns' red
    green: '#00743F', // Papa Johns' green
    yellow: '#FFC627', // Golden yellow
    lightGray: '#f4f4f4', // Light gray background
    darkGray: '#333', // Darker text
  };

  
  const pageContainer: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center', // Center content vertically and horizontally
    minHeight: '100vh',
    padding: '2rem',
    backgroundColor: colorPalette.lightGray,
  };

  const designPreviewContainer: React.CSSProperties = {
    display: 'inline-block', // Wraps the content so the shadow follows the images' size
    textAlign: 'center',
    margin: '2rem',
    padding: '1rem', // Adjust padding if necessary
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
};

  const sizesGridContainer: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', // Responsive grid layout
    gap: '1rem', // Space between grid items
    width: '100%',
    maxWidth: '900px', // Restrict the maximum width for better presentation
    margin: '1rem 0', // Vertical margin
  };

  const totalQuantityHighlight: React.CSSProperties = {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: colorPalette.green,
    margin: '1rem 0', // Add some space above and below the total quantity
  };

  const pageTitle: React.CSSProperties = {
    fontSize: '2.5rem',
    color: '#d9534f', // A shade that complements Papa John's branding.
    marginBottom: '1rem',
    textAlign: 'center',
    fontFamily: '"Lato", sans-serif',
    fontWeight: 300,
  };
  
  const sizeOptionContainer: React.CSSProperties = {
    display: 'grid',
    gridTemplateAreas: `'icon label' 'input input'`,
    gridTemplateColumns: 'auto 1fr', 
    alignItems: 'center',
    gap: '10px', 
    padding: '1rem',
    margin: '1rem',
    border: `1px solid ${colorPalette.lightGray}`, // Use brand's light gray for border
    borderRadius: '8px', 
    backgroundColor: '#fff',
    boxShadow: '0 4px 8px rgba(0,0,0,0.05)', // Softer shadow
    transition: 'box-shadow 0.3s ease-in-out',
    ':hover': {
      boxShadow: '0 6px 12px rgba(0,0,0,0.1)', 
    },
  };
  
  const sizeLabel: React.CSSProperties = {
    gridArea: 'label',
    fontSize: '1.25rem',
    fontWeight: 600,
    color: colorPalette.darkGray,
  };
  
  const sizeInput: React.CSSProperties = {
    gridArea: 'input',
    padding: '12px 15px',
    border: `1px solid ${colorPalette.lightGray}`, // Removed shorthand color from here
    borderRadius: '4px',
    ':focus': {
      borderColor: colorPalette.red,
      boxShadow: '0 0 0 2px rgba(214, 10, 0, 0.2)',
    },
  };
  
  const totalQuantityStyle: React.CSSProperties = {
    marginTop: '20px',
    fontWeight: 'bold',
    fontSize: '1.25rem',
    color: '#00743F', // Papa Johns' green for positive affirmation
  };
  
  const submitButton: React.CSSProperties = {
    backgroundColor: colorPalette.red,
    color: 'white',
    padding: '1rem 2rem',
    fontSize: '1rem',
    fontWeight: 'bold',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    marginTop: '20px',
    transition: 'background-color 0.2s, box-shadow 0.2s',
    ':hover': {
      backgroundColor: colorPalette.yellow,
      boxShadow: '0px 8px 15px rgba(0, 0, 0, 0.1)',
    },
    ':disabled': {
      backgroundColor: '#ccc',
      cursor: 'not-allowed',
    },
  };
  
  const iconStyles: React.CSSProperties = {
    color: colorPalette.red,
    marginRight: '0.5rem',
  };
  
  const sizeWrapper: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #EEEEEE',
    padding: '10px 0',
  };

  const inputDate: React.CSSProperties = {
    width: '100%', // Makes the input span the full width of its parent container
    padding: '10px',
    border: `1px solid ${colorPalette.darkGray}`, // Consistent border color
    borderRadius: '4px',
    ':focus': {
      borderColor: colorPalette.red, // Highlights the border in red when the input is focused
      boxShadow: '0 0 0 2px rgba(214, 10, 0, 0.2)', // Adds a subtle shadow around the input
    },
  };
  
  
  
  const submitButtonHover: React.CSSProperties = {
    backgroundColor: '#FFC627' // A light golden color for hover
  };
  
  const submitButtonDisabled: React.CSSProperties = {
    backgroundColor: '#BBBBBB' // A neutral color when the button is disabled
  };

const mapStateToProps = (state) => ({
    productSizes: state.ActiveProof?.product?.sizes || [],
    loginData: state.LoginData,
    userInfo: state.UserInfo,
    activeProof: state.ActiveProof,
  });
  
  interface PapaJohnsSizeSelectProps {
    productSizes: string[];
    userInfo:    Tgcc.UserInfo;
    loginData:   Tgcc.LoginData;
    activeProof: Tgcc.Proof;
    dispatch?: Dispatch<any>;
  }
  

class _PapaJohnsSizeSelect extends React.Component<PapaJohnsSizeSelectProps, any> {
  topOfPageRef: HTMLDivElement | null = null;

  constructor(props: PapaJohnsSizeSelectProps) {
    super(props);
    this.handleNotesChange = this.handleNotesChange.bind(this);
    this.submitQuantitiesAfterProofCreation = this.submitQuantitiesAfterProofCreation.bind(this);
    this.state = {
      quantities: this.props.productSizes.reduce((acc, size) => ({
        ...acc,
        [size]: '0', // Initialize as a string '0' instead of a number
      }), {}),
      totalQuantity: 0,
      isWaiting: false,
      selectedDesign: null,
      notes: this.props.activeProof?.text?.other || '',
    };
  }

  componentDidMount() {
    this.scrollToTop();
    const activeProofFromStorage = localStorage.getItem('activeProof');
    if (activeProofFromStorage) {
      const activeProof = JSON.parse(activeProofFromStorage);
      this.props.dispatch({
        type: Tgcc.StateAction.SetActiveProof,
        payload: activeProof,
      });
    }
    this.updateSelectedDesignFromGlobalState();
  }
  
  
  
  componentDidUpdate(prevProps) {
    if (prevProps.activeProof !== this.props.activeProof) {
      this.updateSelectedDesignFromGlobalState();
    }
  }
  
  scrollToTop = () => {
    if (this.topOfPageRef) {
      this.topOfPageRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  loadActiveProofFromStorage = () => {
    const activeProofFromStorage = localStorage.getItem('activeProof');
    if (activeProofFromStorage) {
      const activeProof = JSON.parse(activeProofFromStorage);
      this.props.dispatch({
        type: Tgcc.StateAction.SetActiveProof,
        payload: activeProof,
      });
      // Initialize state based on active proof from storage
      this.initializeStateBasedOnActiveProof(activeProof);
    }
  }

  initializeStateBasedOnActiveProof = (activeProof: Tgcc.Proof) => {
    if (activeProof && activeProof.design && activeProof.product && activeProof.product.sizes) {
      const quantities = activeProof.product.sizes.reduce((acc, size) => ({ ...acc, [size]: 0 }), {});
      
      // Use the unary plus (+) operator to convert values to numbers
    const totalQuantity = Object.values(quantities).reduce((sum: number, val: unknown) => sum + (Number(val)), 0);
      
      // Synchronously set the initial state
      this.state = {
        ...this.state,
        quantities,
        selectedDesign: activeProof.design,
        totalQuantity: totalQuantity,
      };
    } else {
      console.log("No active proof, design, or product sizes found in storage.");
    }
}
  
  

  updateSelectedDesignFromGlobalState() {
    const selectedDesign = this.props.activeProof?.design; // Replace with actual path to design in the global state
    this.setState({ selectedDesign });
  }

  getShirtImageFileName = (color: string) => {
    const colorToFileMap = {
      'Heathered Kelly Green': 'LC-KELLY.png',
      'Evergreen': 'LC-EVERGREEN.png',
      'Heathered Red': 'LC-RED.png',
      // Add more mappings as needed
    };
    return colorToFileMap[color] || 'default-shirt-image.png'; // Fallback image file name if color not found
  };

  handleQuantityChange = (size: string, event: React.FormEvent<HTMLInputElement>) => {
    const target = event.currentTarget;
    const value = target.value === '' ? '' : Number(target.value).toString();
  
    this.setState((prevState) => {
      const updatedQuantities = {
        ...prevState.quantities,
        [size]: value,
      };
  
      const totalQuantity = Object.values(updatedQuantities).reduce((sum: number, current: any) => {
        // Parse `current` to an integer, and if it's NaN (not a number), return 0 instead
        const currentValue = parseInt(current, 10);
        return sum + (isNaN(currentValue) ? 0 : currentValue);
      }, 0);
      
  
      return {
        quantities: updatedQuantities,
        totalQuantity,
      };
    });
  };
  
  
  
  handleNotesChange(event) {
    // Dispatch action to update notes in the ActiveProof object in the Redux store
    this.props.dispatch({
        type: Tgcc.StateAction.UpdateProofNotes,
        payload: event.target.value,
    });
}


  
  saveProofRequest = (loginData, proof) => {
    return new Promise((resolve, reject) => {
        // Validate quantities first
        if (!this.validateQuantities()) {
            this.setState({ 
                isWaiting: false,
                error: "Quantities do not meet the submission criteria." // Custom error message
            });
            return reject(new Error("Quantities do not meet the submission criteria."));
        }

        const email = loginData.username;
        this.setState({ isWaiting: true });

        let setDate = new Date(proof.inHandsDate);
        setDate.setHours(setDate.getHours() + 4);

        Request.createProofRequest(email, loginData, proof, (response) => {
            this.setState({ isWaiting: false });
            resolve(response); // Resolve the promise on success
        }, (err) => {
            this.setState({ isWaiting: false });
            reject(err); // Reject the promise on error
        });
    });
};


  submitQuantitiesAfterProofCreation = async (e) => {
    e.preventDefault();
    console.log("Proof submission initiated");

        const fullNotes = _PapaJohnsSizeSelect.internalNotePrefix + this.props.activeProof.notes; // Concatenate the internal prefix with user-entered notes

    // Update the eventName right before submitting the proof
    this.props.dispatch({
      type: Tgcc.StateAction.UpdateEventName,
      payload: "Papa Johns",
    });

    if (!this.props.loginData) {
      this.setState({ error: "Please log in or register.", isWaiting: false });
      return;
    }

    if (!this.validateQuantities()) {
      this.setState({ isWaiting: false });
      return;
    }

    const updatedActiveProof = {
      ...this.props.activeProof,
      notes: fullNotes, // Update the notes property with fullNotes
    };

    try {
      const proofResponse = await this.saveProofRequest(this.props.loginData, updatedActiveProof);
      console.log("Proof created:", proofResponse);
      await this.submitQuantities();
      browserHistory.push('/papajohns/confirm-details');
    } catch (error) {
      console.error("An error occurred:", error);
      this.setState({ error: "An error occurred during the process. Please try again.", isWaiting: false });
    }

    
  };

  
  submitQuantities = async () => {
    const { quantities, totalQuantity } = this.state; // Assuming totalQuantity is already correctly calculated
    let paymentConfig = new Tgcc.PaymentConfig();
    paymentConfig.type = "Traditional";

    paymentConfig.XSmall = quantities.Xsmall?.toString() ?? "0";
    paymentConfig.Small = quantities.Small?.toString() ?? "0";
    paymentConfig.Medium = quantities.Medium?.toString() ?? "0";
    paymentConfig.Large = quantities.Large?.toString() ?? "0";
    paymentConfig.XLarge = quantities.Xlarge?.toString() ?? "0";
    paymentConfig.XXL = quantities["2XLarge"]?.toString() ?? "0";
    paymentConfig.XXXL = quantities["3XLarge"]?.toString() ?? "0";
    paymentConfig.XXXXL = quantities["4XLarge"]?.toString() ?? "0";
    paymentConfig.YXSmall = quantities.YXSmall?.toString() ?? "0";
    paymentConfig.YSmall = quantities.YSmall?.toString() ?? "0";
    paymentConfig.YMedium = quantities.YMedium?.toString() ?? "0";
    paymentConfig.YLarge = quantities.YLarge?.toString() ?? "0";
    paymentConfig.YXLarge = quantities.YXLarge?.toString() ?? "0";
    paymentConfig.Toddler2 = quantities.Toddler2?.toString() ?? "0";
    paymentConfig.Toddler3 = quantities.Toddler3?.toString() ?? "0";
    paymentConfig.Toddler4 = quantities.Toddler4?.toString() ?? "0";
    paymentConfig.Toddler5 = quantities.Toddler5?.toString() ?? "0";
    paymentConfig.Toddler6 = quantities.Toddler6?.toString() ?? "0";
    paymentConfig.Toddler7 = quantities.Toddler7?.toString() ?? "0";
    paymentConfig.Infant6 = quantities.Infant6?.toString() ?? "0";
    paymentConfig.Infant12 = quantities.Infant12?.toString() ?? "0";
    paymentConfig.Infant18 = quantities.Infant18?.toString() ?? "0";
    paymentConfig.Infant24 = quantities.Infant24?.toString() ?? "0";
    paymentConfig.OneSize = quantities.OneSize?.toString() ?? "0";
    

    Object.keys(quantities).forEach(size => {
        paymentConfig[size] = String(quantities[size]);
    });

    paymentConfig.IsSpecialCase = true;
    paymentConfig.quantity = String(totalQuantity);

    paymentConfig.IsSpecialCase = true;

    try {
        const response = await Request.approveProof(
            this.props.loginData,
            this.props.activeProof,
            paymentConfig,
            this.props.userInfo,
            () => {
                console.log("Quantities submitted successfully");
                this.props.dispatch({
                    type: Tgcc.StateAction.ProofAndQuantitiesSubmitted,
                    payload: {
                        activeProof: this.props.activeProof,
                        paymentConfig: paymentConfig,
                        quantities: quantities
                    },
                });
            },
            (error) => {
                console.error("Failed to submit quantities:", error);
                this.setState({
                    error: "Failed to submit quantities. Please try again.",
                    isWaiting: false,
                });
            }
        );
        console.log("Response from approval:", response);
    } catch (error) {
        console.error("An unexpected error occurred:", error);
        this.setState({
            error: "An unexpected error occurred. Please try again.",
            isWaiting: false,
        });
    }
};

  
setError = (msg: string) => {
    this.setState({error: msg, isWaiting: false}, () => {
        console.log(this.state.error)
    });
    return false;
}

validateQuantities = () => {
  const { quantities } = this.state;
  let totalQuantity = 0;

  Object.values(quantities).forEach(qty => {
    // Convert qty to a number, ensuring non-numeric strings become NaN
    const parsedQty = Number(qty);
    // Only add to total if parsedQty is a number
    if (!isNaN(parsedQty)) {
      totalQuantity += parsedQty;
    }
  });

  const isValid = totalQuantity >= 50;
  if (!isValid) {
    this.setError('Total quantity must be 50 or more.');
  }
  return isValid;
};


  formatinHandsDate = (date:Date) => {
    var monthNames = [
        "01", "02", "03",
        "04", "05", "06", "07",
        "08", "09", "10",
        "11", "12"
    ];

    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var today = year + '-' + monthNames[monthIndex] + '-' + day;

    return today;
}


  // Placeholder methods for handling completion and errors
  proofComplete = (response: any) => {
    // Handle proof submission completion
    console.log("Proof submission complete:", response);
  };

  handleInHandsDateChange = (e: React.FormEvent<HTMLInputElement>) => {
    const inHandsDate = e.currentTarget.value;
    // Assuming the logic to dispatch the update is handled elsewhere after this check
    this.props.dispatch({
      type: Tgcc.StateAction.UpdateInHandsDate,
      payload: inHandsDate,
    });
};

  static internalNotePrefix = "**********PAPA JOHNS WEBSITE ORDER**********************\n"; // Static prefix


render() {
    const { isWaiting, quantities, totalQuantity, selectedDesign } = this.state;
    const { activeProof, productSizes } = this.props; // Destructure activeProof from this.props
    
    const minDate = new Date();
    minDate.setDate(minDate.getDate() + 5);
    const minDateString = minDate.toISOString().split('T')[0]; // Format as 'yyyy-MM-dd'

    
    const currentStep = 3;
    const totalSteps = 3;

    const errorDisplay = this.state.error ? (
      <div style={{ color: 'red', marginTop: '1rem' }}>
        {this.state.error}
      </div>
    ) : null;

    const selectedShirtColor = this.props.activeProof?.product?.colorName || 'default';
    const shirtImageFileName = this.getShirtImageFileName(selectedShirtColor);
    const shirtImageUrl = Tgcc.ResolveUrl(`~/images/${shirtImageFileName}`);

    const subtitleText = "Please enter the quantities for each size needed. Remember that the total quantity should be 50 or more to proceed.";

    const notesSection: React.CSSProperties = {
      width: '100%',
      padding: '0.5rem',
      fontSize: '1rem',
      borderColor: '#ddd',
      borderRadius: '4px',
      minHeight: '100px',
      marginBottom: '1rem',
      resize: 'vertical', // Allow vertical resizing
    };

    const labelStyle: React.CSSProperties = {
      display: 'block', // ensures that the label is on a new line
      textAlign: 'center',
      marginTop: '8px',
      fontSize: '0.9rem',
      color: colorPalette.darkGray,
    };
    

    const formattedInHandsDate = activeProof?.inHandsDate
    ? this.formatinHandsDate(new Date(activeProof.inHandsDate))
    : this.formatinHandsDate(new Date());


    const designPreviewSection = selectedDesign ? (
      <div style={designPreviewContainer}>
        <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
          <img
            src={shirtImageUrl}
            alt="Shirt Front"
            style={{ width: '40vw', maxWidth: '300px', borderRadius: '8px' }}
          />
          <span style={labelStyle}>Front</span>
        </div>
        <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
          <img
            src={selectedDesign.previewImage}
            alt="Selected Design"
            style={{ width: '40vw', maxWidth: '300px', borderRadius: '8px' }}
          />
          <span style={labelStyle}>Back</span>
        </div>
      </div>
    ) : (
      <div style={designPreviewContainer}>
        <p>No design selected</p>
      </div>
    );

    return (
       <div ref={element => { this.topOfPageRef = element; }}>
        < PapaJohnsBannerImage />

        <div style={{
          padding: '1rem', // Adjust as needed
          backgroundColor: 'rgb(244, 244, 244)',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)', // Optional shadow for depth
        }}>
          <BackButton />
          <ProgressBar currentStep={currentStep} totalSteps={totalSteps} /> {/* Progress Bar added here */}
        <div style={pageContainer}>
          <h2 style={pageTitle}>Select Sizes and Quantities</h2>
          <p style={{
            textAlign: 'center',
            fontSize: '1.25rem',
            color: '#666666',
            marginBottom: '1rem',
          }}>{subtitleText}</p>
          {designPreviewSection}
          <div style={sizesGridContainer}>
            {productSizes.map((size, index) => (
              <div key={`size-option-container-${index}`} style={sizeOptionContainer}>
                <i className={`fa fa-tshirt`} style={iconStyles}></i>
                <label htmlFor={`size-${size}`} style={sizeLabel}>
                  {size}:
                </label>
                <input
                  key={`size-input-${size}`}
                  id={`size-${size}`}
                  type="number"
                  value={quantities[size] !== undefined && quantities[size] !== '' ? quantities[size] : '0'}
                  onChange={(e) => this.handleQuantityChange(size, e)}
                  style={sizeInput}
                  min="0"
                  max="999"
                />
              </div>
            ))}
          </div>
          
          <div>
              <h3 style={{ fontSize: '1.5rem', marginTop: '1rem' }}>Special Notes or Customizations:</h3>
              <textarea
                  style={notesSection}
                  placeholder="Enter any special notes or customization options here, like 'Papa Johns logo on the back near the collar', design adjustment, etc."
                  value={activeProof?.notes || ''} // Correctly accessing notes from props with optional chaining
                  onChange={this.handleNotesChange}
              />
          </div>

          <div>
            <label style={{ fontSize: '1.5rem', marginTop: '1rem' }} htmlFor="inHandsDate">In-Hands Date</label>
            <input
                style={inputDate}
                type="date"
                key="inHandsDate"
                id="inHandsDate"
                name="inHandsDate"
                value={this.state.inHandsDate}
                min={minDateString}
                onChange={this.handleInHandsDateChange}
              />
            {this.state.rushFeeApplicable && <p style={{ color: 'red', marginTop: '0.5rem' }}>A rush fee of 20% may apply.</p>}
          </div>

          {errorDisplay}
        
          <div style={totalQuantityHighlight}>
            Total Quantity: {totalQuantity}
          </div>
          <button 
            style={submitButton}
            disabled={isWaiting || totalQuantity === 0}
            onClick={!isWaiting ? this.submitQuantitiesAfterProofCreation : undefined}>
            {isWaiting ? 'Processing...' : 'Submit Proof'}
          </button>
        </div>
        </div>
        <PapaJohnsFooter/>
      </div>
      
    );
}


}

export const PapaJohnsSizeSelect = connect(mapStateToProps)(Radium(_PapaJohnsSizeSelect));
